import React from 'react';
import { Paper, Typography } from '@mui/material';
import Table from '../../../Components/Table';
import { FullSizeCenteredFlexBox } from '../../../Components/FlexBox';
import ContentError from '../../../Components/Error/ContentError';
import { useIntl } from 'react-intl';

const columns = [
  {
    id: 'entity',
    label: 'OPERATOR',
    alignment: 'left',
  },
  {
    id: 'practices',
    label: 'PRACTICES',
    alignment: 'center',
  },
  {
    id: 'answeredNum',
    label: 'ANSWERED_CALLS',
    alignment: 'center',
  },
  {
    id: 'redemptionRate',
    label: 'REDEMPTION_RATE',
    alignment: 'center',
    formatCallback: (value, rowData) => {
      const redemptionAvg =
        rowData?.totalPractices && rowData?.totalAnsweredNum
          ? (rowData?.totalPractices / rowData?.totalAnsweredNum) * 100
          : 0;
      const redemptionRate =
        rowData?.practices && rowData?.answeredNum
          ? (rowData?.practices / rowData?.answeredNum) * 100
          : 0;
      return (
        <Typography
          variant="body1"
          color={redemptionRate < redemptionAvg ? 'error' : 'success'}
        >{`${redemptionRate.toFixed(2)}%`}</Typography>
      );
    },
  },
  {
    id: 'accepted',
    label: 'ACCEPTED_PRACTICES',
    alignment: 'center',
  },
  {
    id: 'retired',
    label: 'RETIRED_PRACTICES',
    alignment: 'center',
  },
  {
    id: 'refused',
    label: 'REFUSED_PRACTICES',
    alignment: 'center',
  },
  {
    id: 'waiting',
    label: 'WAITING_PRACTICES',
    alignment: 'center',
  },
];
const TableWrapper = function TableWrapper({ data = [] }) {
  const intl = useIntl();
  return (
    <Paper
      id="pivot-wrapper"
      elevation={3}
      sx={{
        width: '100%',
        minHeight: '600px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '18px',
        gap: '8px',
        overflow: 'hidden',
      }}
    >
      {data?.length === 0 ? (
        <FullSizeCenteredFlexBox justifyContent="center">
          <ContentError text={intl.messages.NO_DATA_AVAILABLE} />
        </FullSizeCenteredFlexBox>
      ) : (
        <Table
          id="table-wrapper-table"
          columns={columns}
          data={data}
          spacing="8px"
          width="100%"
          height="100%"
        />
      )}
    </Paper>
  );
};
export default TableWrapper;
